(function() {
    const selectors = {
        quantityButton: '.minicart-quantity-button',
    }

    function elementReady(selector) {
        return new Promise((resolve, reject) => {
            let el = document.querySelector(selector);
            if (el) {
                resolve(el);
                return
            }
            new MutationObserver((mutationRecords, observer) => {
                // Query for elements matching the specified selector
                Array.from(document.querySelectorAll(selector)).forEach((element) => {
                    resolve(element);
                    //Once we have resolved we don't need the observer anymore.
                    observer.disconnect();
                });
            })
            .observe(document.documentElement, {
                childList: true,
                subtree: true
            });
        });
    }

    elementReady('#atharva_minicart').then((someWidget) => {
        const widget = document.querySelector('#atharva_minicart');
        const htmlDiv = document.createElement('div');
        htmlDiv.setAttribute('id', 'rk-widget-213952');
        htmlDiv.classList.add('rk-bought_together', 'is-visible');

        new MutationObserver(function(mutations) {
            if (mutations[0].attributeName === 'class') {
                setTimeout(() => {
                    document.querySelector('.atharva_minicart_table').after(htmlDiv);
                }, 0);
            }
        }).observe(widget, { attributes: true });
    });

    const reInitFrequentlyBoughtTogether = (e) => {
        const target = e.target;

        const widget = target.closest('#atharva_minicart');
        console.log('widget', widget);

        var oldXHR = window.XMLHttpRequest;

        function newXHR() {
            var realXHR = new oldXHR();
            realXHR.addEventListener("readystatechange", function() {
                console.log('realXHR', realXHR)
                if(realXHR.readyState==4 && realXHR.status==200){
                    setTimeout(() => {
                        widget.classList.add('is-visible');
                    }, 1000);
                }
            }, false);
            return realXHR;
        }
        window.XMLHttpRequest = newXHR;
    }

    elementReady(selectors.quantityButton).then((el) => {
        const quantityButtons = document.querySelectorAll(selectors.quantityButton);
        quantityButtons.forEach(button => {
            button.addEventListener('click', reInitFrequentlyBoughtTogether);
        })
    });
})();
